export default __webpack_public_path__ + "./image/a026b63bef38f0b9d74d12496fd17979.png";